import LdAppLayout from 'lion-vue-shared/components/LdAppLayout/LdAppLayoutContainer';
import { HC_PROPS, initHCProps } from '../index';

export { initHCProps, HC_PROPS };
export default LdAppLayout;
